/**
 * Lottie init — animazioni Lottie dichiarative via data-attribute.
 *
 * Uso (nessun JS aggiuntivo per le pagine future):
 *   <div data-lottie="<?php echo esc_url( get_stylesheet_directory_uri() . '/assets/json/anim.json' ); ?>"
 *        data-lottie-loop="true"></div>
 *
 * Attributi opzionali:
 *   data-lottie-loop="true|false"   (default: true)
 *   data-lottie-speed="1"           (default: 1)
 *   data-lottie-fit="meet|slice"    (default: meet — slice riempie il box
 *                                    ritagliando i lati)
 *
 * Nota sulla dimensione visiva: canvas e padding interni variano molto tra i
 * file, quindi la scala ottica si normalizza lato CSS (es. .value-block__icon
 * usa --lottie-scale per-file, vedi inc/page-values.php). Un ritaglio runtime
 * via getBBox non è affidabile: gli SVG Lottie contengono geometria invisibile
 * (maschere, rect trasparenti) che falsa il bounding box.
 *
 * Comportamento:
 *  - renderer SVG (build "light" di lottie-web, niente canvas/html renderer)
 *  - play/pausa automatici con IntersectionObserver (anima solo in viewport)
 *  - prefers-reduced-motion: carica e mostra l'ultimo frame, statico
 */
import lottie from 'lottie-web/build/player/lottie_light';

( function () {
	'use strict';

	var hosts = document.querySelectorAll( '[data-lottie]' );
	if ( ! hosts.length ) {
		return;
	}

	var reduceMotion = window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;

	function initLottie( host ) {
		var path = host.getAttribute( 'data-lottie' );
		if ( ! path ) {
			return;
		}

		var loop = host.getAttribute( 'data-lottie-loop' ) !== 'false';
		var speed = parseFloat( host.getAttribute( 'data-lottie-speed' ) ) || 1;
		var fit = host.getAttribute( 'data-lottie-fit' ) === 'slice' ? 'slice' : 'meet';

		var anim = lottie.loadAnimation( {
			container: host,
			renderer: 'svg',
			loop: loop,
			autoplay: false,
			path: path,
			rendererSettings: {
				preserveAspectRatio: 'xMidYMid ' + fit,
			},
		} );

		anim.setSpeed( speed );

		if ( reduceMotion ) {
			// Frame finale statico (stato "completo" dell'icona).
			anim.addEventListener( 'DOMLoaded', function () {
				anim.goToAndStop( Math.max( anim.totalFrames - 1, 0 ), true );
			} );
			return;
		}

		// Anima solo quando l'elemento è visibile.
		var observer = new IntersectionObserver( function ( entries ) {
			entries.forEach( function ( entry ) {
				if ( entry.isIntersecting ) {
					anim.play();
				} else {
					anim.pause();
				}
			} );
		}, { threshold: 0.3 } );
		observer.observe( host );
	}

	for ( var i = 0; i < hosts.length; i++ ) {
		initLottie( hosts[ i ] );
	}
}() );
